export default "__VITE_ASSET__499da0af__"